import { Component, OnInit } from '@angular/core';
import { from, isObservable, Observable, of, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { CommandEvent, commandEvent } from '../load/command/command.component';

export enum DialogButtonColour {
  default,
  primary,
  secondary,
  action,
  danger
}

export class DialogButton {
  label: string = '';
  action: Observable<any> = of();
  complete: () => void = () => { };
  colour: DialogButtonColour = DialogButtonColour.default;

  constructor() { }
}

// TODO: component will be replaced by lds-dialog [future release]
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  title: string = '';
  message: string | string[] | Observable<string> | Observable<string[]> = '';
  public messages$: Observable<string[]> = of([])
  buttons: DialogButton[] = [];
  preformatted: boolean = false

  action: Observable<any> = of();
  complete: () => void = () => {};

  private actionButtonClick$: Subject<null> = new Subject<null>();
  public action$: Observable<CommandEvent<null>> = commandEvent(
    this.actionButtonClick$,
    _ => this.action);

  constructor() { }

  ngOnInit(): void {
    this.messages$ = (!isObservable(this.message) ? of(this.message) : this.message)
      .pipe(map(x => Array.isArray(x) ? x : [x]))
  }

  public triggerAction(action: Observable<any>): void {
    this.action = action;
    this.actionButtonClick$.next(null)
  }

  public setComplete(complete: () => void): void {
    this.complete = complete;
  }

  public getAppearance(colour: DialogButtonColour): any {
    switch (colour) {
      case DialogButtonColour.action: return 'action';
      case DialogButtonColour.danger: return 'danger';
      case DialogButtonColour.primary: return 'primary';
      case DialogButtonColour.secondary: return 'secondary';
      case DialogButtonColour.default:
      default: return 'default';
    }
  }
}
